<template>
  <div class="org-view-retired">
    <div class="org-view-retired__icon">
      <img
        class="org-view-retired__wrecking-ball"
        src="https://storage.googleapis.com/cg-bb-dvimages-pd-b963/other/WreckingBall.png"
        alt="Wrecking ball"
      />
    </div>
    <h1 class="org-view-retired__title">Under Destruction</h1>
    <p class="org-view-retired__message">
      DV1 OrgView has been retired, please use
      <a
        class="org-view-retired__link"
        href="https://dv.bb.guardiansfrontoffice.com/#/"
        target="_blank"
        rel="noopener noreferrer"
      >
        DV2
      </a>
      instead.
    </p>
  </div>
</template>

<script>
export default {
  name: 'OrgViewRetired',
};
</script>

<style lang="scss" scoped>
.org-view-retired {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 320px;
  padding: 32px 24px;
  text-align: center;
  color: #1a1a1a;
  background: #f5f5f5;
}

.org-view-retired__icon {
  margin-bottom: 16px;
}

.org-view-retired__wrecking-ball {
  display: block;
  width: 96px;
  height: auto;
}

.org-view-retired__title {
  margin: 0 0 12px;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.2;
}

.org-view-retired__message {
  margin: 0;
  max-width: 420px;
  font-size: 16px;
  line-height: 1.5;
}

.org-view-retired__link {
  color: darken($indBlue, 5%);
  font-weight: 600;
  text-decoration: underline;

  &:hover,
  &:focus {
    color: darken($indBlue, 15%);
  }
}
</style>
